export default __webpack_public_path__ + "static/media/Wifi.e067b3d2.svg";